import React, { useState, useEffect } from 'react';
import { Box, Card, Paper, Stack, Tab, Tabs } from '@mui/material';
import PropTypes from 'prop-types';
import Carousel from '../../common/carousel';
import { isValidArray } from '../../../utils/is-array';
import PageHeader from '../page-header/index';
import { Pagination, Thumbs } from 'swiper';
import 'swiper/css/thumbs';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import { mediaFilter } from '../../../utils/filter-media';
const CarImageModel = ({ auction, handleClose, activeCarImagesSection, setActiveSlideIndexConnect }) => {
    const { inspectionMedia = [] } = auction || {};
    const carMediaKeys = inspectionMedia.map(v => v.title);
    const imageSectionIndex = carMediaKeys?.indexOf(activeCarImagesSection?.category) || 0;
    const [currentTabIndex, setCurrentTabIndex] = useState({ id: 0, title: '' });
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [initialSlide, setInitialSlide] = useState(-1);
    useEffect(() => {
        setCurrentTabIndex({ id: imageSectionIndex, title: activeCarImagesSection?.category });
        if (swiperItems?.length && activeCarImagesSection?.category) {
            const index = swiperItems?.findIndex(v => v?.url === activeCarImagesSection?.url);
            setInitialSlide(index || 0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeCarImagesSection]);

    const handleChange = (title, newValue) => {
        setThumbsSwiper(null);
        setCurrentTabIndex({ id: newValue, title });
        let index = -1;
        swiperItems?.forEach((v, i) => {
            if (v?.category === title && index === -1) {
                index = i;
            }
        });
        setInitialSlide(index);
    };

    const handleSlideChange = (slide) => {
        const slider = swiperItems?.find((v, i) => i === slide.activeIndex);
        setActiveSlideIndexConnect(slide?.activeIndex);
        const tabValue = carMediaKeys?.findIndex(key => key === slider?.category);
        if (currentTabIndex !== tabValue) {
            handleChange(slider?.category, tabValue);
        }
    };

    const settings = {
        slidesPerView: 1,
        initialSlide: initialSlide,
        style: {
            '--swiper-navigation-color': '#fff',
            '--swiper-pagination-color': '#fff',
        },
        pagination: {
            type: 'fraction'
        },
        modules: [Thumbs, Pagination],
        thumbs: { swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null },
        onSlideChange: handleSlideChange
    };

    const thumbsSettings = {
        slidesPerView: 3.5,
        spaceBetween: 4,
        initialSlide: initialSlide,
        onSwiper: setThumbsSwiper,
        pagination: {
            dynamicBullets: true,
            clickable: true,
            dynamicMainBullets: 3
        },
        watchSlidesProgress: true,
        modules: [Pagination]
    };

    const swiperItems = mediaFilter(inspectionMedia)?.flat();

    return (
        <Card className='w-full h-full relative bg-white' sx={{ borderRadius: '0' }}>
            <PageHeader handleBack={handleClose} handleClose={handleClose} />
            <Stack gap={2}>
                <Paper sx={{ width: '100%', background: 'transparent' }} elevation={0}>
                    {isValidArray(carMediaKeys) &&
                        <Tabs variant="scrollable" className='shadow mb-2' classes={{ root: 'inspection-report-tab h-8', scrollButtons: 'ip-scroll-btn w-8' }} allowScrollButtonsMobile value={currentTabIndex.id} aria-label="basic tabs">
                            {carMediaKeys?.map((item, index) => {
                                return (
                                    <Tab label={item} key={`tab_${index}`} onClick={handleChange.bind(null, item, index)} classes={{ selected: `font-bold bg-v-light-br` }} id={`simple-tab-${index}`} />
                                );
                            })}
                        </Tabs>
                    }
                    <TabPanel key={`${currentTabIndex?.id > 0 && currentTabIndex?.id}`}>
                        {isValidArray(swiperItems) && initialSlide >= 0 && <Carousel
                            items={swiperItems}
                            height={250}
                            zoom={true}
                            isGallery={true}
                            isPartialGallery={true}
                            settings={{ ...settings }}
                            thumbsSettings={thumbsSettings}
                        />}
                    </TabPanel>
                </Paper>
            </Stack>
        </Card>
    );
};
CarImageModel.propTypes = {
    auction: PropTypes.any,
    activeCarImagesSection: PropTypes.string,
    setActiveCarImagesSection: PropTypes.func,
    handleClose: PropTypes.func,
    setActiveSlideIndexConnect: PropTypes.func
};

export default CarImageModel;

const TabPanel = ({ children, key, index, ...other }) => {
    return (
        <div key={key}
            role="tabpanel"
            hidden={false}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            <Box>
                {children}
            </Box>
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    key: PropTypes.any,
    value: PropTypes.any.isRequired
};
